import { NavLink } from 'react-router-dom';
import type { Menubar } from '@/types';
import styles from './PrimaryNav.module.css';

interface PrimaryNavProps {
  menuItems: Menubar[];
}

export function PrimaryNav({ menuItems }: PrimaryNavProps) {
  return (
    <nav
      className={styles.nav}
      aria-label="Primary navigation"
      role="navigation"
    >
      <div className={`container ${styles.inner}`}>
        <ul className={styles.list}>
          {menuItems.map((item) => (
            <li key={item.menuId} role="listitem">
              {item.url ? (
                <NavLink
                  to={item.url.startsWith('/') ? item.url : `/${item.url}`}
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ''}`
                  }
                  end
                >
                  {item.label}
                </NavLink>
              ) : (
                // Parent item with sub-menu (url is null from DB) — rendered as button
                // TODO: wire up dropdown when sub-nav UX is implemented
                <button type="button" className={styles.link}>
                  {item.label}
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
